export default [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/register',
    name: '/register',
    meta: {
      requiresAuth: false
    },
    component: () => import(/* webpackChunkName: "register" */ '../../views/Register.vue')
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      requiresAuth: false
    },
    component: () => import(/* webpackChunkName: "login" */ '../../views/Login.vue')
  },
  {
    path: '/home',
    name: 'home',
    meta: {
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: "home" */ '../../views/Home.vue')
  },
  {
    path: '/register',
    name: 'register',
    meta: {
      requiresAuth: false
    },
    component: () => import(/* webpackChunkName: "register" */ '../../views/Register.vue')
  }
]
